<template>
    <div>
        <div ref="editor" class="wangeditor"></div>
        <input type="hidden" v-model="value">
    </div>
</template>

<script>
    import  E from 'wangeditor';
    export default {
        name: "Wangeditor",
        props:{
            uploadImgServer:{
              type:String,
              default:function () {
                  return "";
              }
            },showLinkImg:{
              type:Boolean,
              default:function () {
                  return true;
              }
            },
            value:{
                type:String,
                default:function () {
                    return "";
                }
            }
        },
        watch:{
          value(){
              if(this.editor2 && !this.editor2.txt.html().replace(/<[^>]+>/g,"") ){
                  this.editor2.txt.html(this.value);
              }
          }
        },
        data(){
           return  {editor2:null}
        },
        mounted() {
            let vm = this;
            let editor2 = new E(this.$refs.editor);
            editor2.config.uploadImgServer = vm.uploadImgServer ;
            editor2.config.uploadVideoServer = vm.uploadImgServer + '?type=VIDEO' ;
            editor2.config.showLinkVideo = false;
            editor2.config.showLinkImg = false;
            editor2.config.uploadVideoTimeout =  1000 * 60 * 5
            editor2.config.uploadImgMaxSize =  30 * 1024 * 1024;
            editor2.config.pasteFilterStyle = false;
            editor2.config.zIndex = 100;
            editor2.config.onchange = function (html) {
                vm.$emit('input',html);
            };

            editor2.config.customInsertVideo = function (videoUrl) {
                // videoUrl 是返回的视频地址

                // 往编辑器插入 html 内容
                editor2.cmd.do(
                    'insertHTML',
                    `<video src="${videoUrl}" controls style="background: #000000;" ></video>`
                )

            }

            // editor2.config.customUploadVideo = function (resultFiles, insertVideoFn) {
            //     // resultFiles 是 input 中选中的文件列表
            //     // insertVideoFn 是获取视频 url 后，插入到编辑器的方法
            //
            //     // 上传视频，返回结果，将视频地址插入到编辑器中
            //     insertVideoFn("http://192.168.0.102:8081/api/cmsCommon/downloadVideo?code=71fded20f8d446ccb02d4a4adc86c274")
            // }
            editor2.create();
            this.editor2 = editor2;
            this.editor2.txt.html(this.value);

        }
    }
</script>

<style scoped>

    .wangeditor{
         z-index: -1;
    }

</style>
